import styled, { css } from 'styled-components';
import type { Maybe } from 'yup';

import { Box } from '@/components/Box';
import { Container } from '@/components/Container';
import { Flex } from '@/components/Flex';

import { visibilityControl } from '../../Card.styles';

export const TopBannerWrapper = styled(Box)<{
  $visibleInDesktop?: Maybe<boolean>;
  $visibleInMobile?: Maybe<boolean>;
}>`
  position: relative;
  ${({ $visibleInDesktop, $visibleInMobile }) => css`
    ${visibilityControl($visibleInDesktop, $visibleInMobile)}
  `};
`;
export const Wrapper = styled(Container)`
  position: absolute;
  top: 0;
  left: 50%;
  height: 100%;
  transform: translateX(-50%);
  ${({ theme }) => css`
    z-index: ${theme.zIndex.baseCmsCard};
  `}
`;

export const Content = styled(Flex)`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  flex-direction: column;
  justify-content: center;
`;

export const Heading = styled(Flex)`
  flex-direction: column;
  justify-content: center;
  min-height: 170px;

  ${({ theme }) => css`
    ${theme.media.md.up} {
      min-height: 125px;
      margin-bottom: -${theme.spacing(2)};
    }
  `}
`;
